import {WlShare} from "./share.component";
import {defineWebComponent} from "../webcomponents-utils";

export * from './share.component';
export default WlShare;

defineWebComponent('wl-share', WlShare);
